import { Stack, Typography } from "@mui/material"
import { RuleSetReferenceSummary } from "./rule-set-reference-summary"

export function RuleSetReferenceOption(props, option) {
    return (
        <li {...props} key={option.id}>
            <Stack spacing={0.5} sx={{ width: "100%", py: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {option.label}
                </Typography>
                <RuleSetReferenceSummary summary={option.summary} />
            </Stack>
        </li>
    )
}
